<template>
  <div class="container">

    <Navigation />

    <h1 class="title">ARCHIVE</h1>

    <ImageList v-bind:imagelist="images"></ImageList>

  </div>
</template>

<script>

import Vue from 'vue'
import axios from 'axios'
import ImageList from '@/components/ImageList'
import Navigation from '@/components/Navigation'

export default {
  name: 'Archive',
  components: {
    Navigation,
    ImageList
  },
  data() {
    return {
      images: []
    }
  },
  methods: {
    getAllImages() {
      return axios.get('/data/images.json')
        .then((res) => {
          this.images = res.data.map(item => {
            let filename = `/img/archive/${item.filename}`,
                filename_thumbnail = `/img/archive/thumbs/${item.filename_thumbnail}`

            return {
              filename, filename_thumbnail
            }
          })
        })
    }
  },
  created() {
    this.getAllImages()
      .then(res => {
      })
  }

}
</script>
